/**
 * Stable error codes returned under the top-level `error` key of an API error body.
 * Keep these in sync with their backend counterparts.
 */

// App\Organization\Exceptions\InvalidOrganizationContextException::ERROR_CODE
export const API_ERROR_ORGANIZATION_CONTEXT_INVALID = "organization_context_invalid";

// App\Organization\Exceptions\OrganizationContextRequiredException::ERROR_CODE
export const API_ERROR_ORGANIZATION_CONTEXT_REQUIRED = "organization_context_required";

export const API_ERROR_GROUP_TEMPLATE_LOCATION_HAS_UPCOMING_CLASSES =
  "errors.group_class_template_location_has_upcoming_classes";

export const API_ERROR_REFERRAL_BSN_BIRTH_DATE_MISMATCH = "errors.referral_bsn_birth_date_mismatch";

export const API_ERROR_REFERRAL_CREATE_PATIENT_BSN_MISMATCH = "errors.referral_create_patient_bsn_mismatch";
